import styled from "styled-components";
import {getCssSizeValue, getHtmlFromRedactorField} from "@/utils/utils";

const Wrapper = styled.div`
    background: ${({theme}) => theme.colors.chilliRed};
    color: ${({theme}) => theme.colors.whiteSmoke};
	padding: ${getCssSizeValue(8)} ${getCssSizeValue(24)} ${getCssSizeValue(24)} 0;
	
	.header {
		margin-bottom: ${getCssSizeValue(16)};
		padding-left: ${getCssSizeValue(16)};
	}
	
	.description {
        padding-left: ${getCssSizeValue(24)};
	}
`

function getData(src) {
	return {
		header: src?.header || '',
		description: src?.description || ''
	}
}

export default function CornerBadge({badge}) {
	const { header, description } = getData(badge)

	return (
		<Wrapper>
			<div className='header typo-strawford typo-strawford-34'>{header}</div>
			<a href={`tel:${description}`} className='description typo-borna typo-borna-30'>{description}</a>
		</Wrapper>
	)
}